export default "__VITE_ASSET__dcb94811__"